class FJLoadMore {
  constructor() {
    document.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const button = event.target.closest('[data-load-more]');
    if (!button) return;
    this.loadMore(button);
  }

  async loadMore(button) {
    const url = button.dataset.nextUrl;
    if (!url) return;

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Loading...';

    try {
      const response = await fetch(url);
      const htmlText = await response.text();
      const html = new DOMParser().parseFromString(htmlText, 'text/html');

      const newGrid = html.getElementById('fj-product-grid');
      const currentGrid = document.getElementById('fj-product-grid');
      if (newGrid && currentGrid) {
        Array.from(newGrid.children).forEach((card) => {
          currentGrid.appendChild(card);
        });
      }

      const newPagination = html.getElementById('fj-collection-pagination');
      const currentPagination = document.getElementById('fj-collection-pagination');
      if (newPagination && currentPagination) {
        currentPagination.replaceWith(newPagination);
      }
    } catch (e) {
      console.error('Failed to load more products:', e);
      button.disabled = false;
      button.textContent = originalText;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new FJLoadMore();
});